module.exports = __webpack_public_path__ + "img/logoaplicacion.78b0942.png";